import styled from "styled-components";
import tw from "twin.macro";
import { Theme } from "../../context";

export const JiffyContainer = styled.div`
  ${tw`lg:pb-20 font-clash text-white`}
`;

export const JiffyTestimonialHeading = styled.h1<{ rooTheme?: Theme }>`
  ${tw` font-[600]  text-[40px] `}
  ${({ rooTheme }) =>
    rooTheme !== "dark" ? tw`text-white` : tw`text-basebackground`}
`;

export const JiffyTestimonialParagraph = styled.p<{ rooTheme?: Theme }>`
  ${tw`py-3 font-[400]`}
  ${({ rooTheme }) =>
    rooTheme !== "dark" ? tw`text-gray-300` : tw`text-black`}
`;

export const JiffyCards = styled.div`
  ${tw`flex flex-col md:flex-row gap-3 justify-center flex-wrap `}

  > div {
    ${tw`md:self-start`}
  }
  > div:nth-child(1) {
    ${tw``}
  }

  > div:nth-child(2) {
  }

  > div:nth-child(3) {
  }
`;

export const JiffyCard = styled.div<{ rooTheme?: Theme }>`
  ${tw`rounded-3xl p-2 shadow-sm `}
  background:rgba(255, 255, 255, 0.1);
  flex-basis: 32%;
  &:hover {
    ${tw`scale-[0.98] transition-all ease-in-out duration-500 cursor-pointer`}
  }

  ${({ rooTheme }) =>
    rooTheme !== "dark"
      ? tw``
      : tw`text-basebackground border-[1.5px] border-gray-200`}
`;

export const JiffyCardQuote = styled.h2<{ rooTheme?: Theme }>`
  ${tw`text-gray-400 font-[600] w-[90%] pt-4 pb-12 text-[16px]`};
  ${({ rooTheme }) => (rooTheme !== "dark" ? tw`` : tw`text-black opacity-50`)}
`;

export const JiffyCardName = styled.h4<{ rooTheme?: Theme }>`
  ${tw`font-[600] text-[14px]`}
  ${({ rooTheme }) => (rooTheme !== "dark" ? tw`` : tw`text-basebackground `)}
`;

export const JiffyCardOccupation = styled.div<{ rooTheme?: Theme }>`
  ${tw` text-[12px] text-basebackground font-[400]`}
  ${({ rooTheme }) => (rooTheme !== "dark" ? tw`text-white` : tw``)}
`;

export const JiffyImage = styled.img``;

export const JiffyContent = styled.div`
  ${tw`text-center py-5`}
`;

export const JiffyCardContainer = styled.div`
  ${tw`flex items-center gap-3`}
`;

export const JiffyController = styled.div`
  ${tw`py-6 px-3`}
`;

export const JiffyActivator = styled.div<{ rooTheme?: Theme }>`
  ${tw`py-8 flex justify-center items-center gap-2`};
  span {
    ${tw`h-1 w-5 block rounded-xl`};
    background: ${({ rooTheme }) =>
      rooTheme !== "dark"
        ? "rgba(255, 255, 255, 0.4)"
        : "rgba(21, 97, 166, 0.08)"};
  }
  > span:first-child {
    ${tw`h-1 w-44 bg-buttondefault`}
  }
`;
